<template>
<div class="tabs">
  <div v-for="tab in tabs" 
    @click="changeTab(tab.name)" 
    :key="tab.name" 
    class="tab" 
    :class="{'is-active': tab.name == active}">
    {{$t(tab.code)}}
  </div>
</div>
</template>
<script>
export default {
  props: [ 'tabs', 'active' ],
  methods: {
    changeTab(key){
      this.$emit('update', key)
    }
  }
}
</script>
<style lang="scss" scoped>
.tabs{
  border-bottom: 1px solid #e8e8e8;
  background: #f7f7f7;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 0 20px;
  display: flex;
  overflow-x: auto;
  .tab{
    padding: 10px;
    color: #404040;
    cursor: pointer;
    margin: 0 5px;
    &:first-child{
      margin-left: 0;
    }
    &.is-active{
      color: #101010;
      padding-bottom: 5px;
      border-bottom: 5px solid #ffd800;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PageTabs.vue?57297d68